<template>
    <div class="row pad-to-15">
        <div class="col-md-12">
            <!--General Top Bar-->
            <!-- <general-top-bar :title="$t('pages.approvals')"></general-top-bar> -->
            <!--End General Top Bar-->

            <div class="card">
                <div class="card-content row">
                    <div class="col-md-3 col-sm-6 col-xs-12 form-group">
                        <label class="control-label text-purple">{{$t('marketingCampaigns.groups')}}</label>
                        <v-select
                            :options="statusOptions"
                            v-model="selectedStatus"
                            label="label"
                            @input="fetchData"
                            placeholder="Select status"
                        ></v-select>
                    </div>
                    <a
                        class="btn add mar-rt-10 mar-lt-20 mar-to-25" 
                        :title="$t('general.deny')" 
                        @click="handleAccept(0, 1)">
                        {{ $t('general.accept') }} {{ $t('general.all') }}
                    </a>

                    <a
                        class="btn delete mar-rt-10 mar-to-25" 
                        :title="$t('general.deny')" 
                        @click="handleAccept(0, 0)">
                        {{ $t('general.deny') }} {{ $t('general.all') }}
                    </a>
                    <data-tables class="campaign-table width-table"
                        v-loading="loading"
                        :data="pendingRequests"
                        :action-def="defaultActionDef()"
                        :pagination-def="paginationDefPending"
                        :table-props="{'border': false}"
                        style="width: 100%">
                    
                    <!-- Existing columns... -->

                    <!-- Email Column -->
                    <el-table-column
                        :min-width="45"
                        prop="id"
                        label="ID">
                        <template slot-scope="props">
                        {{ props.row.id }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        :min-width="45"
                        prop="email"
                        label="Email">
                        <template slot-scope="props">
                        {{ props.row.user.email }}
                        </template>
                    </el-table-column>

                    <!-- Created At Column -->
                    <el-table-column
                        :min-width="45"
                        prop="created_at"
                        :label="$t('general.registrationDate')">
                        <template slot-scope="props">
                        {{ props.row.created_at }}
                        </template>
                    </el-table-column>

                    <!-- Accept / Decline Action Buttons Column -->
                    <el-table-column
                        :min-width="50"
                        :label="$t('general.actions')">
                        <template slot-scope="props">
                            <div v-if="!selectedStatus.value" class="display-flex" style="align-items: center;">
                                <a
                                    class="btn add mar-rt-10" 
                                    :title="$t('general.accept')" 
                                    @click="handleAccept(props.row.id, 1)">
                                    {{$t('general.accept')}}
                                </a>

                                <a
                                    class="btn delete mar-rt-10" 
                                    :title="$t('general.deny')" 
                                    @click="handleAccept(props.row.id, 0)">
                                    {{$t('general.deny')}}
                                </a>
                            </div>
                            <div v-else class="display-flex" style="align-items: center;">
                                <a
                                    v-if="props.row.is_approved"
                                    style="pointer-events: none; cursor: default;"
                                    class="btn add mar-rt-10"
                                    :title="$t('general.accept')">
                                    {{$t('general.accepted')}}
                                </a>

                                <a
                                    v-if="!props.row.is_approved"
                                    style="pointer-events: none; cursor: default;"
                                    class="btn delete mar-rt-10" 
                                    :title="$t('general.deny')">
                                    {{$t('general.denied')}}
                                </a>
                            </div>
                        </template>
                    </el-table-column>

                    </data-tables>
                    <el-pagination
                        class="active-pagination width-table"
                        :total="paginationDefPending.totalRecords"
                        :page-size="paginationDefPending.perPage"
                        :pager-count="pagerCount"
                        :current-page="paginationDefPending.page"
                        layout="prev, pager, next, total"
                        @current-change="handlePageChange($event)"
                        @prev-click="handlePageChange($event)"
                        @next-click="handlePageChange($event)">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    /* eslint-disable */
    // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
    import 'sweetalert2/dist/sweetalert2.css'
    import {Pagination} from 'element-ui'


    export default{
        components: {
            // GeneralTopBar,
            Pagination
        },
        created: function () {
            let data = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
            }
            this.getData(data)
        },
        data () {
            return {
                groupsData: [],
                modelValidations: {
                    title: {
                        required: true
                    }
                },
                loading: true,
                pagerCount: 7,
                pendingRequests: [],
                oldPendingRequests: [],
                paginationDefPending: {
                    page: null,
                    totalPages: null,
                    perPage: null,
                    totalRecords: null,
                    show: true
                },
                selectedStatus: { label: this.$t('general.pending'), value: 0 },
                statusOptions: [
                    { label: this.$t('general.pending'), value: 0 },
                    { label: this.$t('general.completed'), value: 1 }
                ]
            }
        },
        methods: {
            fetchData () {
                if (!this.selectedStatus) {
                    return
                }
                
                this.loading = true
                let data = {
                    token: this.$session.get('token'),
                    company_id: this.$session.get('selectedCompany'),
                    isApproved: this.selectedStatus.value
                }
                this.getData(data)
            },
            getData (data) {
                this.apiRequest('/registration-approval', 'GET', data, (response) => {
                    if (response.status) {
                        this.pendingRequests = response.data.data

                        this.paginationDefPending.page = response.data.page
                        this.paginationDefPending.totalPages = response.data.totalPages
                        this.paginationDefPending.perPage = response.data.perPage
                        this.paginationDefPending.totalRecords = response.data.totalRecords
                    }
                    this.$nextTick(function () {
                        this.loading = false
                    })
                })
            },
            handleAccept (id, accept) {
                let data = {
                    token: this.$session.get('token'),
                    company_id: this.$session.get('selectedCompany'),
                    id: id,
                    is_approved: accept,
                }

                this.apiRequest('/registration-approval', 'PUT', data, (response) => {
                    this.getData(data)
                })
            },
            handlePageChange (page) {
                var data = {
                    token: this.$session.get('token'),
                    company_id: this.$session.get('selectedCompany'),
                    page: page,
                    perPage: this.paginationDefPending.perPage
                }

                this.getData(data)
            }
        }
    }
</script>
<style>
  .btn-icon-small {
    border-radius: 25px !important;
    padding: 7px 5px !important;
    }

  .border-bottom {
    border-bottom: 1px solid #ccc;
  }
  .header {
    padding-left: 15px;
  }
  .content-groups {
    margin: 10px 15px;
  }
  .group, .no_group {
    background: #ffffffbf;
    margin-top: 10px;
    padding: 12px 30px;
    font-size: 16px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 11px;
  }
  .no_group {
    border: none;
  }
  .edit_input {
    border: none !important;
    border-bottom: 1px solid #ccc !important;
  }
  .groupModal .vm--modal{
      background-color: #F4F6FF !important;
      border-radius: 10px !important;
  }
  .groupModal .vm--modal .card {
        border: none;
        background-color: #F4F6FF;
        margin-bottom: 0px;
        border-radius: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Customers/Approvals/Approvals.vue